import React, { useState, useEffect } from 'react';
import { apiClient } from '../services/authService';
import './ResultadosExamenes.css';

function ResultadosExamenes() {
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    cargarResultados();
  }, []);

  const cargarResultados = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await apiClient.get('/estudiante/resultados');
      setResultados(res.data);
    } catch (err) {
      console.error('Error al cargar resultados:', err);
      setError('Error loading results. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="resultados-container">
        <div className="resultados-loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="resultados-container">
        <div className="resultados-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="resultados-container">
      <div className="resultados-header">
        <h2>Exam Results</h2>
        <p className="resultados-subtitle">
          View your completed exams and results
        </p>
      </div>

      {resultados.length === 0 ? (
        <div className="resultados-empty">
          <div className="resultados-empty-icon">📊</div>
          <h3>No completed exams yet</h3>
          <p>Complete an exam to see your results here.</p>
        </div>
      ) : (
        <div className="resultados-grid">
          {resultados.map((resultado) => {
            const titulo =
              resultado.examen_titulo ||
              resultado.examen_codigo ||
              `Exam ${resultado.examen_id}`;
            const scoreText = resultado.total_preguntas
              ? `${resultado.puntuacion_bruta}/${resultado.total_preguntas}`
              : `${resultado.puntuacion_bruta}`;
            const fecha = new Date(resultado.fecha_completado).toLocaleDateString(
              'en-US',
              { year: 'numeric', month: 'long', day: 'numeric' }
            );

            return (
              <article key={resultado.id} className="resultado-card">
                <div className="resultado-card-top">
                  <h3 className="resultado-examen-titulo">{titulo}</h3>
                  <span
                    className={`resultado-badge ${
                      resultado.aprobado ? 'aprobado' : 'reprobado'
                    }`}
                  >
                    {resultado.aprobado ? '✓ Passed' : '✗ Failed'}
                  </span>
                </div>

                {resultado.puntuacion_bruta !== null && (
                  <div className="resultado-scores-row">
                    <div className="resultado-score-box">
                      <span className="resultado-score-label">Score</span>
                      <span className="resultado-score-value">{scoreText}</span>
                    </div>
                    {resultado.puntuacion_escalada !== null && (
                      <div className="resultado-scaled-box">
                        <span className="resultado-escalada-label">
                          Scaled Score
                        </span>
                        <span className="resultado-escalada-value">
                          {resultado.puntuacion_escalada}/1000
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <div className="resultado-fecha">Completed: {fecha}</div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ResultadosExamenes;
